import React from 'react';
import { ReactComponent } from 'Common/components/Icons/checkbox-outlined-rounded.svg';

const CheckBoxOutlinedRounded = () => <ReactComponent className="MuiSvgIcon-root" />;

export default CheckBoxOutlinedRounded;
